import SearchForm from './SearchForm'
import Router from 'next/router'
import { partFormInputsMobile, partFormInputs, partAdvancedInputs } from '@components/search/partFormInputs'
import { PART_LINK_BASE } from '@constants/searchFormLinks'
import searchFormLink from '@utils/links/searchFormLink'

const PartForm = ({ overrideDefaultValues }) => {
    const navigateToSearchPage = (data) => {
        const link = searchFormLink({
            data,
            linkBase: PART_LINK_BASE,
            isMakeModelBase: false,
        })

        Router.push(link)
    }

    return <SearchForm
        inputs={partFormInputs}
        mobileInputs={partFormInputsMobile}
        dataKey="part"
        overrideDefaultValues={overrideDefaultValues}
        onSubmit={navigateToSearchPage}
        actionBar={{
            paliwo: null,
            clear: true,
            advancedOptions: partAdvancedInputs,
        }} />
}

export default PartForm